export class Chain {
    id: number;
    name: string;
    storeCount: number;

    constructor(options?: Partial<Chain>) {
        Object.assign(this, options);
    }
}
